import { toError } from "./toError";
let installed = false;
// Web global handlers: `error`/`unhandledrejection` window events. Installed once, no teardown.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const installGlobalHandlers = (dispatch, _flush) => {
    if (installed) {
        return;
    }
    installed = true;
    window.addEventListener("error", (event) => {
        dispatch(toError(event.error, event.message), { mechanism: { handled: false, type: "onerror" } });
    });
    window.addEventListener("unhandledrejection", (event) => {
        dispatch(toError(event.reason, "Unhandled promise rejection"), {
            mechanism: { handled: false, type: "onunhandledrejection" },
        });
    });
};
export { installGlobalHandlers };
